import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-ink">
      <div className="grid gap-12 px-5 py-16 sm:px-8 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <p className="font-display text-5xl font-extrabold lowercase tracking-tight text-bone sm:text-7xl">aligndept</p>
          <p className="mt-4 max-w-sm text-sm font-light leading-relaxed text-neutral-400">
            For those who trust their path, embrace what makes them different, and understand that nothing happens by coincidence.
          </p>
        </div>
        <div className="lg:col-span-6">
          <p className="font-mono text-[10px] tracking-[0.3em] text-fade">NAVIGATE</p>
          <div className="mt-4 flex flex-col gap-3">
            {[
              ["Shop", "/shop"],
              ["Collections", "/collections"],
              ["Lookbook", "/lookbook"],
              ["Our Story", "/story"],
              ["Account", "/account"],
            ].map(([label, to]) => (
              <Link key={to} to={to} className="w-fit text-sm text-bone/70 transition-colors hover:text-bone">
                {label}
              </Link>
            ))}
          </div>
        </div>
      </div>
      <div className="flex flex-col items-start justify-between gap-3 border-t border-white/10 px-5 py-6 sm:flex-row sm:items-center sm:px-8">
        <p className="font-mono text-[10px] tracking-[0.3em] text-fade">© 2026 ALIGNDEPT. ALL PATHS RESERVED.</p>
        <p className="font-mono text-[10px] tracking-[0.3em] text-bone/50">NO COINCIDENCES.</p>
      </div>
    </footer>
  );
}
